import React, { useState } from 'react';
import { Minus, Plus } from 'lucide-react';

/**
 * Disclosure list. One item open at a time — the pattern the FAQ blocks on
 * Pricing and the Help Center both use.
 */
const Accordion = ({ items, idPrefix = 'faq' }) => {
  const [open, setOpen] = useState(null);

  return (
    <div className="space-y-2.5">
      {items.map((item, i) => {
        const isOpen = open === i;
        const panelId = `${idPrefix}-panel-${i}`;
        return (
          <div
            key={item.q}
            className="overflow-hidden rounded-xs bg-surface shadow-soft"
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              aria-controls={panelId}
              className="focus-ring flex w-full items-center justify-between gap-4 px-6 py-4 text-left"
            >
              <span className="font-bold text-content">{item.q}</span>
              <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-pill bg-surface-muted text-content-muted">
                {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </span>
            </button>
            {isOpen && (
              <div
                id={panelId}
                className="border-t border-line px-6 pb-5 pt-4 text-[0.9375rem] leading-relaxed text-content-muted"
              >
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
